<template>
  <b-card v-if="!!option" id="page-arquitecturaAzure-form" no-body class="mb-0">
    <b-card-header>
      <b-card-title
        ><h2>
          {{ $t(getTitle()) }}
          {{ $t("pages.azure.title").toLowerCase() }}
        </h2></b-card-title
      >
      <b-button variant="primary" @click="goBack">
        <feather-icon icon="ArrowLeftIcon" />
        {{ $t("back") }}
      </b-button>
    </b-card-header>
    <b-card-body>
      <validation-observer ref="arquitecturaAzureform">
        <b-form>
          <b-row>
            <!-- Solo para crear -->
            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('company'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('company'))"
                  label-for="company"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    ref="companySelect"
                    :key="selectKey"
                    v-model="arquitecturaAzure.guidCompany"
                    input-id="company"
                    :options="allCompaniesSelect"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :placeholder="$t(label('company'))"
                    :reduce="(option) => option.guid"
                    :disabled="option == 2"
                  >
                  </v-select>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('containerAppName'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('containerAppName'))"
                  label-for="containerAppName"
                  :state="errors.length > 0 ? false : null"
                >
                  <b-form-input
                    id="containerAppName"
                    v-model="arquitecturaAzure.containerAppName"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('containerAppName'))"
                    :disabled="option == 2"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('variableWaClientId'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('variableWaClientId'))"
                  label-for="variableWaClientId"
                  :state="errors.length > 0 ? false : null"
                >
                  <b-form-input
                    id="variableWaClientId"
                    v-model="arquitecturaAzure.variableWaClientId"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('variableWaClientId'))"
                    :disabled="option == 2"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" sm="12" md="6" lg="6" xl="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('imageTag'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('imageTag'))"
                  label-for="imageTag"
                  :state="errors.length > 0 ? false : null"
                >
                  <b-form-input
                    id="imageTag"
                    v-model="arquitecturaAzure.imageTag"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('imageTag'))"
                    :disabled="option == 2"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- Para editar-->
            <b-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="option != 1">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('pathPlainText'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('pathPlainText'))"
                  label-for="pathPlainText"
                  :state="errors.length > 0 ? false : null"
                >
                  <b-form-input
                    id="pathPlainText"
                    v-model="arquitecturaAzure.pathPlainText"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('pathPlainText'))"
                    :disabled="option == 2"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="option != 1">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('pathImg'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('pathImg'))"
                  label-for="pathImg"
                  :state="errors.length > 0 ? false : null"
                >
                  <b-form-input
                    id="pathImg"
                    v-model="arquitecturaAzure.pathImg"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('pathImg'))"
                    :disabled="option == 2"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="option != 1">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('pathVoice'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('pathVoice'))"
                  label-for="pathVoice"
                  :state="errors.length > 0 ? false : null"
                >
                  <b-form-input
                    id="pathVoice"
                    v-model="arquitecturaAzure.pathVoice"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('pathVoice'))"
                    :disabled="option == 2"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="option != 1">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('pathStartBot'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('pathStartBot'))"
                  label-for="pathStartBot"
                  :state="errors.length > 0 ? false : null"
                >
                  <b-form-input
                    id="pathStartBot"
                    v-model="arquitecturaAzure.pathStartBot"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('pathStartBot'))"
                    :disabled="option == 2"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="option != 1">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('pathStopBot'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('pathStopBot'))"
                  label-for="pathStopBot"
                  :state="errors.length > 0 ? false : null"
                >
                  <b-form-input
                    id="pathStopBot"
                    v-model="arquitecturaAzure.pathStopBot"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('pathStopBot'))"
                    :disabled="option == 2"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="option != 1">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('urlBot'))"
                rules="required||url"
              >
                <b-form-group
                  :label="$t(label('urlBot'))"
                  label-for="urlBot"
                  :state="errors.length > 0 ? false : null"
                >
                  <b-form-input
                    id="urlBot"
                    v-model="arquitecturaAzure.urlBot"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('urlBot'))"
                    :disabled="option == 2"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="option != 1">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('apiKey'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('apiKey'))"
                  label-for="apiKey"
                  :state="errors.length > 0 ? false : null"
                >
                  <b-form-input
                    id="apiKey"
                    v-model="arquitecturaAzure.apiKey"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('apiKey'))"
                    :disabled="option == 2"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="option != 1">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('resourceGroup'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('resourceGroup'))"
                  label-for="resourceGroup"
                  :state="errors.length > 0 ? false : null"
                >
                  <b-form-input
                    id="resourceGroup"
                    v-model="arquitecturaAzure.resourceGroup"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('resourceGroup'))"
                    :disabled="option == 2"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="option != 1">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('registry'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('apiKey'))"
                  label-for="registry"
                  :state="errors.length > 0 ? false : null"
                >
                  <b-form-input
                    id="registry"
                    v-model="arquitecturaAzure.registry"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('registry'))"
                    :disabled="option == 2"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="option != 1">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('imageName'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('imageName'))"
                  label-for="imageName"
                  :state="errors.length > 0 ? false : null"
                >
                  <b-form-input
                    id="imageName"
                    v-model="arquitecturaAzure.imageName"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('imageName'))"
                    :disabled="option == 2"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="option != 1">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('environmentId'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('environmentId'))"
                  label-for="environmentId"
                  :state="errors.length > 0 ? false : null"
                >
                  <b-form-input
                    id="environmentId"
                    v-model="arquitecturaAzure.environmentId"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('environmentId'))"
                    :disabled="option == 2"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="option != 1">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('location'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('location'))"
                  label-for="location"
                  :state="errors.length > 0 ? false : null"
                >
                  <b-form-input
                    id="location"
                    v-model="arquitecturaAzure.location"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('location'))"
                    :disabled="option == 2"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="option != 1">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('cpu'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('cpu'))"
                  label-for="cpu"
                  :state="errors.length > 0 ? false : null"
                >
                  <b-form-input
                    id="cpu"
                    v-model="arquitecturaAzure.cpu"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('cpu'))"
                    :disabled="option == 2"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="option != 1">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('memory'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('memory'))"
                  label-for="memory"
                  :state="errors.length > 0 ? false : null"
                >
                  <b-form-input
                    id="memory"
                    v-model="arquitecturaAzure.memory"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('memory'))"
                    :disabled="option == 2"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="option != 1">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('variableGuidCompany'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('variableGuidCompany'))"
                  label-for="variableGuidCompany"
                  :state="errors.length > 0 ? false : null"
                >
                  <b-form-input
                    id="variableGuidCompany"
                    v-model="arquitecturaAzure.variableGuidCompany"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('variableGuidCompany'))"
                    :disabled="option == 2"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="option != 1">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('variableServerUrl'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('variableServerUrl'))"
                  label-for="variableServerUrl"
                  :state="errors.length > 0 ? false : null"
                >
                  <b-form-input
                    id="variableServerUrl"
                    v-model="arquitecturaAzure.variableServerUrl"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('variableServerUrl'))"
                    :disabled="option == 2"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" sm="12" md="6" lg="6" xl="6" v-if="option != 1">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('variableApiToken'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('variableApiToken'))"
                  label-for="variableApiToken"
                  :state="errors.length > 0 ? false : null"
                >
                  <b-form-input
                    id="variableApiToken"
                    v-model="arquitecturaAzure.variableApiToken"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('variableApiToken'))"
                    :disabled="option == 2"
                  />
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              class="d-flex justify-content-end align-items-center"
              cols="12"
            >
              <b-button
                v-if="option != 2"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click.prevent="onSubmit"
              >
                {{ $t("save") }}
              </b-button>
              <b-button
                v-if="option == 1"
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                variant="outline-secondary"
                @click="onCancel"
              >
                {{ $t("cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-body>
  </b-card>
</template>

<script>
import _ from "lodash";

import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import {
  BInputGroup,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BFormCheckbox,
  BForm,
  BFormTextarea,
  BToast,
  BMedia,
  BFormInvalidFeedback,
  BFormDatepicker,
  BFormTimepicker,
  BListGroup,
  BListGroupItem,
  BCollapse,
  BIcon,
  BFormFile,
} from "bootstrap-vue";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import {
  showLoading,
  stopLoading,
  getParams,
  isValidUrl,
} from "@core/utils/utils";
import { required, integer, min } from "@validations";
import vSelect from "vue-select";

import { getCatalog } from "@core/api/request/catalogs";

import { postFile } from "@core/api/request/catalogs";
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

import { allClientsByCompany } from "@core/api/request/clients";
import { allServices } from "@core/api/request/services";
import { allEmployeesByCompany } from "@core/api/request/employees";
import { allCompanies } from "@core/api/request/company";
import {
  createOrEditAzureArqu,
  getAzureArqu,
  companyChangesazure,
} from "@core/api/request/azureArquitecture";
import flatPickr from "vue-flatpickr-component";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import Cleave from "vue-cleave-component";
import moment from "moment";
const arquitecturaAzure = {
  idArquitecturaAzure: null,
  guidCompany: null,
  variableWaClientId: null,
  containerAppName: null,
  imageTag: null,
  urlBot: null,
  pathPlainText: null,
  pathImg: null,
  pathVoice: null,
  apiKey: null,
  pathStartBot: null,
  pathStopBot: null,
  resourceGroup: null,
  registry: null,
  imageName: null,
  environmentId: null,
  location: null,
  cpu: null,
  memory: null,
  variableGuidCompany: null,
  variableServerUrl: null,
  variableApiToken: null,
};
export default {
  components: {
    BInputGroup,
    ValidationProvider,
    ValidationObserver,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    vSelect,
    BFormTextarea,
    BToast,
    BFormInvalidFeedback,
    BMedia,
    BFormDatepicker,
    BFormTimepicker,
    VueTelInput,
    flatPickr,
    BListGroup,
    BListGroupItem,
    BCollapse,
    BIcon,
    Cleave,
    BFormFile,
  },

  directives: {
    Ripple,
  },
  data() {
    return {
      isSaveMode: true,
      companyGuid: null,
      required,
      integer,
      min,
      loading: false,
      totalRows: null,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 50, 100],
      striped: false,
      bordered: false,
      borderless: false,
      outlined: false,
      headVariant: "dark",
      arquitecturaAzure: Object.assign(arquitecturaAzure),
      option: "",
      listRecurrency: [],
      photo: null,
      fileData: {},
      loading: false,
      openTelInput: false,
      allClients: [],

      allCompaniesSelect: [],
      previouscompany: null,
      previouscompanyName: null,
      selectKey: 0,
      isHistoryCollapsed: false,
      companyHistory: [],
      modalPaid: false,
      fields: [
        { label: "coin_types", key: "coinTypes", sortable: false },
        { label: "referencePay", key: "referencePay", sortable: false },
        { label: "amounth", key: "amounth", sortable: false },
        { label: "voucher", key: "voucher", sortable: false },
        { label: "companyPay", key: "timeBreakEnd", sortable: false },
        { label: "action", key: "actions", sortable: false },
      ],
      listPaymentMethods: [],
      listPaymentarquitecturaAzure: [],
      voucher: null,
    };
  },
  created() {
    localize("es");
  },
  computed: {},
  mounted() {
    this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
    this.initialize();
  },
  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.companyGuid = guid;
      this.resetData();
      this.loadData();
    },
  },
  methods: {
    toggleHistoryCollapse() {
      this.isHistoryCollapsed = !this.isHistoryCollapsed;
    },
    isNumber(event) {
      const charCode = event.which ? event.which : event.keyCode;

      // Permitir solo números del 0 al 9
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      }

      if (charCode === 48 && event.target.value.length === 0) {
        event.preventDefault();
      }
    },

    resetData() {},
    paidOn() {
      this.modalPaid = true;
    },
    chargeParams() {
      const arrParams = [];

      arrParams.push(`page,1`);

      arrParams.push(`rows,99999`);
      arrParams.push(`active,true`);
      return getParams(arrParams);
    },
    async loadData() {
      await Promise.all([
        // this.loadClientsByCompanie(),
        // this.loadEmployeeByCompanie(),
        // this.loadServicesByCompanie(),
        // this.loadRecurrency(),
        this.loadcompany(),
      ]);
    },

    label(field) {
      return `pages.azure.form.label.${field}`;
    },

    labelHeader(field) {
      return `pages.azure.table.tableHeader.${field}`;
    },

    getTitle() {
      if (this.option === 1) return "register";
      else if (this.option === 2) return "show";
      else if (this.option === 3) return "edit";
    },

    loadcompany() {
      const param = this.chargeParams();
      allCompanies(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          this.allCompaniesSelect = data?.items || [];
        })
        .catch((error) => {
          console.log("error", error);
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },

    async initialize() {
      this.option = this.$route.params.option;

      if (this.option === undefined) {
        router.push({ name: "azureArchitecture" }).catch(() => {});
      }

      await this.loadData();
      switch (this.option) {
        case 1:
          this.onCancel();
          break;
        case 2:
          if (this.$route.params.idArquitecturaAzure === undefined) {
            router.push({ name: "azureArchitecture" }).catch(() => {});
          }
          this.isSaveMode = false;
          await this.showarquitecturaAzure(
            this.$route.params.idArquitecturaAzure,
          );

          break;
        case 3:
          if (this.$route.params.idArquitecturaAzure === undefined) {
            router.push({ name: "azureArchitecture" }).catch(() => {});
          }

          this.isSaveMode = true;
          await this.showarquitecturaAzure(
            this.$route.params.idArquitecturaAzure,
          );

          break;
      }
    },

    onSubmit() {
      this.$refs.arquitecturaAzureform.validate().then((success) => {
        if (success) {
          showLoading();

          const data = {
            idArquitecturaAzure: this.arquitecturaAzure.idArquitecturaAzure,
            guidCompany: this.arquitecturaAzure.guidCompany,
            variableWaClientId: this.arquitecturaAzure.variableWaClientId,
            containerAppName: this.arquitecturaAzure.containerAppName,
            imageTag: this.arquitecturaAzure.imageTag,
            urlBot: this.arquitecturaAzure.urlBot,
            pathPlainText: this.arquitecturaAzure.pathPlainText,
            pathImg: this.arquitecturaAzure.pathImg,
            pathVoice: this.arquitecturaAzure.pathVoice,
            apiKey: this.arquitecturaAzure.apiKey,
            pathStartBot: this.arquitecturaAzure.pathStartBot,
            pathStopBot: this.arquitecturaAzure.pathStopBot,
            resourceGroup: this.arquitecturaAzure.resourceGroup,
            registry: this.arquitecturaAzure.registry,
            imageName: this.arquitecturaAzure.imageName,
            environmentId: this.arquitecturaAzure.environmentId,
            location: this.arquitecturaAzure.location,
            cpu: this.arquitecturaAzure.cpu,
            memory: this.arquitecturaAzure.memory,
            variableGuidCompany: this.arquitecturaAzure.variableGuidCompany,
            variableServerUrl: this.arquitecturaAzure.variableServerUrl,
            variableApiToken: this.arquitecturaAzure.variableApiToken,
          };
          createOrEditAzureArqu(
            data,
            this.arquitecturaAzure.idArquitecturaAzure,
          )
            .then((resp) => {
              stopLoading();
              // if (resp.data) {
              //   this.alertToast("danger", `${resp.data.message}`);
              //   return;
              // }
              this.alertToast(
                "success",
                `${
                  this.option == 1
                    ? "Registros exitoso"
                    : "Actualización exitosa"
                }`,
              );
              this.goBack();
            })
            .catch((error) => {
              this.alertToast("danger", error.message);
              stopLoading();
            });

          stopLoading();
        } else {
          this.alertToast("danger", "Debe llenar todos los campos");
        }
      });
    },

    async showarquitecturaAzure(id) {
      showLoading();
      await getAzureArqu(id)
        .then((resp) => {
          const arquitecturaAzure = _.get(resp, "data");
          this.arquitecturaAzure = Object.assign(this.arquitecturaAzure, {
            idArquitecturaAzure: arquitecturaAzure.idArquitecturaAzure,
            guidCompany: arquitecturaAzure.guidCompany,
            variableWaClientId: arquitecturaAzure.variableWaClientId,
            containerAppName: arquitecturaAzure.containerAppName,
            imageTag: arquitecturaAzure.imageTag,
            urlBot: arquitecturaAzure.urlBot,
            pathPlainText: arquitecturaAzure.pathPlainText,
            pathImg: arquitecturaAzure.pathImg,
            pathVoice: arquitecturaAzure.pathVoice,
            apiKey: arquitecturaAzure.apiKey,
            pathStartBot: arquitecturaAzure.pathStartBot,
            pathStopBot: arquitecturaAzure.pathStopBot,
            resourceGroup: arquitecturaAzure.resourceGroup,
            registry: arquitecturaAzure.registry,
            imageName: arquitecturaAzure.imageName,
            environmentId: arquitecturaAzure.environmentId,
            location: arquitecturaAzure.location,
            cpu: arquitecturaAzure.cpu,
            memory: arquitecturaAzure.memory,
            variableGuidCompany: arquitecturaAzure.variableGuidCompany,
            variableServerUrl: arquitecturaAzure.variableServerUrl,
            variableApiToken: arquitecturaAzure.variableApiToken,
          });

          stopLoading();
        })
        .catch((error) => {
          console.log("error", error);
          stopLoading();
          this.alertToast("danger", error.message);
        });
    },

    onCancel() {
      this.arquitecturaAzure = Object.assign({
        idArquitecturaAzure: null,
        guidCompany: null,
        variableWaClientId: null,
        containerAppName: null,
        imageTag: null,
        urlBot: null,
        pathPlainText: null,
        pathImg: null,
        pathVoice: null,
        apiKey: null,
        pathStartBot: null,
        pathStopBot: null,
        resourceGroup: null,
        registry: null,
        imageName: null,
        environmentId: null,
        location: null,
        cpu: null,
        memory: null,
        variableGuidCompany: null,
        variableServerUrl: null,
        variableApiToken: null,
      });
    },

    alertToast(type = null, title = null, message = null) {
      this.$toast({
        component: ToastificationContent,
        position: "top-right",
        props: {
          title,
          icon:
            type == "danger"
              ? "XIcon"
              : type == "success"
              ? "CheckIcon"
              : "AlertTriangleIcon",
          variant: type,
          text: message,
        },
      });
    },

    goBack() {
      this.$refs.arquitecturaAzureform.reset();
      router.back();
    },
  },
};
</script>

<style scoped></style>
